<div class="card table-card">
    <div class="table-toolbar">
        <h1 class="table-toolbar__title">Devices</h1>
        <div class="sb-filter-holder sb-filter-holder--inline">
            <!-- Search — matches on Dev ID, Dev Type Name, Dev Name, ESN Code,
                 InvType, Latitude, Longitude, Optmizer Number, Software Version. -->
            <div class="btn-group input-wrapper sb-filter-search-group" role="group">
                <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                    (input)="searchData($event)">
                <button type="button" class="btn sb-filter-search-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
        <button class="btn btn-dark rounded" (click)="downloadReport()">
            <ng-container *ngIf="!isDownloading">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    class="me-2">
                    <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Download
            </ng-container>
            <ng-container *ngIf="isDownloading">
                <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                Downloading
            </ng-container>
        </button>
    </div>

    <div class="table-wrap" [class.is-loading]="isLoadingTable">
        <div class="loaderwrapper" *ngIf="isLoadingTable">
            <span class="loader"></span>
        </div>
        <div class="table-main">
            <div class="table-responsive sticky-head">
                <table class="table-data text-center">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Dev ID</th>
                            <th scope="col">Dev Type Name</th>
                            <th scope="col">Dev Name</th>
                            <th scope="col">ESN Code</th>
                            <th scope="col">InvType</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                            <th scope="col">Optmizer Number</th>
                            <th scope="col">Software Version</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!isLoadingTable; else LoadingRow">
                            <ng-container *ngIf="devicesList && devicesList.length>0 else noRow">
                                <tr *ngFor="let row of devicesList;let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{row.devId}}</td>
                                    <td>{{row.devType}}</td>
                                    <td>{{row.devName}}</td>
                                    <td>{{row.esnCode}}</td>
                                    <td>{{row.invType || '---'}}</td>
                                    <td>{{row.latitude}}</td>
                                    <td>{{row.longitude}}</td>
                                    <td>{{row.optimizerNumber}}</td>
                                    <td>{{row.softwareVersion}}</td>
                                    <td>
                                        <span class="badge badge-custom"
                                            [ngClass]="row.is_removed? 'badge-danger':'badge-success'">
                                            {{row.is_removed? 'In-active':'Active'}}
                                        </span>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #noRow>
    <tr>
        <td colspan="100%">
            <div class="fw-semibold text-center">
                No data found
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
